import { render } from "./ContentSearch.vue?vue&type=template&id=0685d478"
import script from "./ContentSearch.vue?vue&type=script&lang=js"
export * from "./ContentSearch.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__